var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4079 5.95293C15.2928 4.68236 17.7072 4.68236 19.5921 5.95293C22.0276 7.5881 25.2891 10.0519 26.9411 11.3225C27.6082 11.8417 28 12.6483 28 13.5211V23.1112C28 25.6634 26.0198 27.7294 23.5737 27.7294H9.42634C6.9802 27.7294 5 25.6634 5 23.1112V13.6647C5 12.814 5.37063 12.0185 6.01657 11.4992C7.65792 10.1955 10.9512 7.61019 13.4079 5.95293Z",
    fill: "#74B743",
    stroke: "#74B743",
    strokeWidth: 1.8111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3643 18.835H14.6344C13.3748 18.835 12.3594 19.9603 12.3594 21.356V27.7291H20.6394V21.356C20.6394 19.9603 19.6239 18.835 18.3643 18.835Z",
    fill: "#E3F1D9",
    stroke: "#E3F1D9",
    strokeWidth: 1.7745,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeActive);
export default __webpack_public_path__ + "static/media/home-active.f9d9ee4e6d322a54ae9fba52339a0c0c.svg";
export { ForwardRef as ReactComponent };